import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
//引入pinia
import pinia from "./pinia"
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhLocale from "../node_modules/element-plus/lib/locale/lang/zh-cn";
const app = createApp(App);

//引入使用icon图标
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
}


app.use(ElementPlus, { locale: zhLocale })
app.use(router)
app.use(pinia)
app.mount('#app')
